<template>
  <div class="view_box" :class="isAni ? 'ani':''">
    <div class="title">618活动效果回顾</div>
    <template v-if="data.marketingSmsNum618 && data.marketingSmsNum618 != '--'">
      <div>今年618，店铺整体营销ROI：<span class="font_color">{{ data.avgRoi618 }}&nbsp;</span></div>
      <div>今年618，店铺使用<span class="font_color">&nbsp;{{ data.bestRoiName618 }}&nbsp;</span>的营销策略效果最好，ROI：<span class="font_color">{{ data.bestRoiVal618 }}&nbsp;</span></div>
      <div>此次营销活动共计带来GMV<span class="font_color">&nbsp;{{ data.bestRoiMoney618 }}&nbsp;</span>元</div>
    </template>

    <template v-if="data.marketingSmsNum618 && data.marketingSmsNum618 != '--'">
      <div style="margin-top: 30px;">颇为不易的一年，</div>
      <div>店铺成功开启了大促红利的第一章！</div>
    </template>
    <template v-else>
      <div style="margin-top: 30px;">今年618似乎没有进行精准营销哦~</div>
      <div>下次大促试试，会有惊喜呢！</div>
    </template>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    isAni:{
      type:Boolean,
      default:true,
    },
    data: {
      type: Object,
      default: ()=> {}
    }
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
@keyframes view_box_s {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.ani{
  animation: view_box_s 1.5s ease-in;
  animation-fill-mode: both;
  border-radius: 16px;
}
.view_box {
  position: relative;
  width: 100%;
  height: 100%;

  padding: 50px;
  font-size: 14px;
  color: #000000;
  line-height: 16px;
  font-family: PingFang SC;
  background-image: url("../../assets/images/yearReport/P6.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  div {
    font-family: PingFang SC;
    width: 100%;
    margin-bottom: 12px;
  }

  .title {
    font-size: 24px;
    font-weight: bold;
    line-height: 28px;
    margin-bottom: 30px;
  }

  .font_color {
    color: #0b79ff;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
  }
}
</style>
